module.exports = __webpack_public_path__ + "media/images/favicons/favicon-160x160-fce4efd41025f87157ff12f6418120a7.png";